'use client'
import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useProductDetailPriceHistories } from '@/shared/ui/history-chart-component/use-product-detail-price-histories'
export type HistoryChartHeaderProps = {}

export const HistoryChartHeader = ({
  className,
  ...props
}: HistoryChartHeaderProps & HTMLAttributes<HTMLDivElement>) => {
  const { isShow, setIsShow } = useProductDetailPriceHistories()

  return (
    <div className={cn(className)} {...props}>
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-body-02-medium text-gray-6">가격변동차트</h2>
          <div className="text-heading-02-bold">
            <h3>
              변화하는 쿠팡가를
              <br /> 그래프로 확인해보세요.
            </h3>
          </div>
        </div>
        <div
          className="cursor-pointer rounded-sm border p-1"
          onClick={() => setIsShow(!isShow)}
        >
          {isShow ? (
            <ChevronUp className="size-4 text-gray-6" />
          ) : (
            <ChevronDown className="size-4 text-gray-6" />
          )}
        </div>
      </div>
    </div>
  )
}
